export const scopeStringId = "contact"